import LandingLoadingSpinner from './LandingLoadingSpinner';

export default LandingLoadingSpinner;
